/**
 * BookmarksActivityPanel — Spatial bookmarks
 */
import React from 'react';
import { Box } from '@mui/material';
import { BookmarksPanel } from '../../BookmarksPanel';

const BookmarksActivityPanel: React.FC = () => (
  <Box sx={{ height: '100%' }}>
    <BookmarksPanel />
  </Box>
);

export default BookmarksActivityPanel;
